var layout_default = {
  "layout": "_9fF3k",
  "cell": "I2k6U"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
